<template>
  <div class="users-list">
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <CustomersCard
          v-for="item of items"
          :id="item.id"
          :key="item.id"
          :status="item.status"
          :name="item.name"
          :access-group="item.accessGroup"
          :companies="item.companies"
          :dealers="item.dealers"
          :level="item.bonusProgramLevel"
          @clickOnOrder="onClickRow({ id: item.id })"
        />
      </div>
      <SkeletonLoaderCard v-else :table-headers="tableHeaders" />
    </template>

    <OurTable
      v-else
      :headers="tableHeaders"
      :items="items"
      :table-fixed="false"
      class="users-list-table"
      @clickRow="onClickRow"
    >
      <template #cell-companies="{ value }">
        <div class="company-block">
          <div v-if="value.length">
            <div v-for="val in value" :key="val.id" class="text">{{ val.name }}<span>,</span></div>
          </div>
          <div v-else class="text">{{ "–" }}</div>
        </div>
      </template>

      <template #cell-dealers="{ value }">
        <div class="company-block">
          <div v-if="value.length" class="title">
            <div v-for="val in value" :key="val.id" class="text">
              {{ val.firstName }} {{ val.lastName }}<span>,</span>
            </div>
          </div>
          <div v-else class="text">{{ "–" }}</div>
        </div>
      </template>

      <template #cell-status="{ value }">
        <OurTag size="md" :text="value?.text" :color="value?.color" />
      </template>
    </OurTable>

    <OurPagination
      v-if="isMoreThanOnePage"
      :current-page="paginationData.currentPage"
      :per-page="paginationData.perPage"
      :total="paginationData.total"
      @pageChange="onPageChange"
    />
  </div>
</template>

<script>
import CustomersCard from "@/components/MobileCards/CustomersCard.vue";
import { mapGetters } from "vuex";
import SkeletonLoaderCard from "@/ui/loader/SkeletonLoaderCard.vue";
export default {
  name: "CustomersList",
  components: { CustomersCard, SkeletonLoaderCard },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    paginationData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    tableHeaders() {
      const data = [
        {
          value: "id",
          text: this.$t("page.users.id"),
          thClass: "w-24",
          tdClass: "max-w-[2rem] min-w-[5rem]",
        },
        {
          value: "name",
          text: this.$t("page.customers.title"),
          thClass: "w-[10rem]",
          tdClass: "max-w-[12rem] min-w-[10rem]",
        },
        {
          value: "companies",
          text: this.$t("page.customers.companies"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[10rem] min-w-[10rem]",
        },
        {
          value: "accessGroup",
          text: this.$t("page.customers.accessGroup"),
          thClass: "w-[10rem]",
          tdClass: "max-w-[12rem] min-w-[10rem]",
        },
        {
          value: "dealers",
          text: this.$t("page.customers.users"),
          thClass: "w-[8rem]",
          tdClass: "max-w-[12rem] min-w-[12rem]",
        },
        {
          value: "bonusProgramLevel",
          text: this.$t("page.customers.bonusProgramLevel"),
          thClass: "w-[7rem]",
          tdClass: "max-w-[9rem] min-w-[7rem] capitalize",
        },
        {
          value: "status",
          text: this.$t("page.dealersCompany.status"),
          thClass: "w-[7rem]",
          tdClass: "max-w-[9rem] min-w-[7rem]",
        },
      ];

      return data;
    },

    isMoreThanOnePage() {
      return this.paginationData.lastPage > 1;
    },

    routePage() {
      return Number.parseInt(this.$route.query.page, 10) || 1;
    },
  },

  watch: {
    routePage(newPage) {
      if (newPage !== this.paginationData.currentPage) {
        this.$emit("pageChange", newPage);
      }
    },
  },

  methods: {
    onPageChange(page) {
      this.$emit("pageChange", page);

      if (page !== this.routePage) {
        const query = { ...this.$route.query };

        delete query.page;

        const nextQuery = page === 1 ? query : { ...query, page };

        this.$router.push({ name: this.$route.name, query: nextQuery });
      }
    },

    onClickRow(row) {
      this.$emit("onClickRow", row.id);
    },
  },
};
</script>

<style lang="postcss" scoped>
.users-list {
  .company-block title {
    @apply flex flex-wrap gap-x-2 gap-y-1;
  }
}
.text:last-child span {
  display: none;
}
</style>
